import { render, staticRenderFns } from "./AuthorityList.vue?vue&type=template&id=7cbcf6c2&scoped=true"
import script from "./AuthorityList.vue?vue&type=script&lang=js"
export * from "./AuthorityList.vue?vue&type=script&lang=js"
import style0 from "./AuthorityList.vue?vue&type=style&index=0&id=7cbcf6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbcf6c2",
  null
  
)

export default component.exports